export default {
  name: 'Now',
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleGo() {
      this.$dic.now[this.$route.name].url && window.open(this.$dic.now[this.$route.name].url);
    }
  }
};